export default "__VITE_ASSET__rjTR14Vg__"